import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';

const SelectSubEstadoInstCancelada = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    defaultProps,
    isMulti,
    estadoEsp
}) => {
    const [selectedValue, setSelectedValue] = useState(value);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };
    const [options, setOptions] = useState([
        {
            value: 'TIEMPO DE ESPERA',
            label: 'TIEMPO DE ESPERA',
        },
        {
            value: 'NO CUENTA CON TARJETA DE CREDITO',
            label: 'NO CUENTA CON TARJETA DE CREDITO',
        },
        {
            value: 'NO BRINDA MOTIVO',
            label: 'NO BRINDA MOTIVO',
        },
        {
            value: 'CONTRATA OTRO PROVEEDOR - COMBO DE SERVICIOS',
            label: 'CONTRATA OTRO PROVEEDOR - COMBO DE SERVICIOS',
        },
        {
            value: 'CONTRATA OTRO PROVEEDOR - DESCUENTOS/PROMOCIONES',
            label: 'CONTRATA OTRO PROVEEDOR - DESCUENTOS/PROMOCIONES',
        },
        {
            value: 'CONTRATA OTRO PROVEEDOR - PRECIO MAS BAJO',
            label: 'CONTRATA OTRO PROVEEDOR - PRECIO MAS BAJO',
        },
        {
            value: 'CONTRATA OTRO PROVEEDOR - SERVICIOS ADICIONALES',
            label: 'CONTRATA OTRO PROVEEDOR - SERVICIOS ADICIONALES',
        },
        {
            value: 'CONTRATA OTRO PROVEEDOR - MAYOR VELOCIDAD',
            label: 'CONTRATA OTRO PROVEEDOR - MAYOR VELOCIDAD',
        }
    ]);
    useEffect(() => {
        if(estadoEsp){
            setOptions([
                {
                    value: 'TIEMPO DE ESPERA',
                    label: 'TIEMPO DE ESPERA',
                },
                {
                    value: 'NO CUENTA CON TARJETA DE CREDITO',
                    label: 'NO CUENTA CON TARJETA DE CREDITO',
                },
                {
                    value: 'NO BRINDA MOTIVO',
                    label: 'NO BRINDA MOTIVO',
                },
                {
                    value: 'CONTRATA OTRO PROVEEDOR - COMBO DE SERVICIOS',
                    label: 'CONTRATA OTRO PROVEEDOR - COMBO DE SERVICIOS',
                },
                {
                    value: 'CONTRATA OTRO PROVEEDOR - DESCUENTOS/PROMOCIONES',
                    label: 'CONTRATA OTRO PROVEEDOR - DESCUENTOS/PROMOCIONES',
                },
                {
                    value: 'CONTRATA OTRO PROVEEDOR - PRECIO MAS BAJO',
                    label: 'CONTRATA OTRO PROVEEDOR - PRECIO MAS BAJO',
                },
                {
                    value: 'CONTRATA OTRO PROVEEDOR - SERVICIOS ADICIONALES',
                    label: 'CONTRATA OTRO PROVEEDOR - SERVICIOS ADICIONALES',
                },
                {
                    value: 'CONTRATA OTRO PROVEEDOR - MAYOR VELOCIDAD',
                    label: 'CONTRATA OTRO PROVEEDOR - MAYOR VELOCIDAD',
                },
                {
                    value: 'PRE-SERVICIO DUPLICADO',
                    label: 'PRE-SERVICIO DUPLICADO',
                },
                {
                    value: 'INFRAESTRUCTURA DEL CLIENTE INADECUADA',
                    label: 'INFRAESTRUCTURA DEL CLIENTE INADECUADA',
                },
            ])
        }
    }, [estadoEsp])
    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = options.find(it=>it.value === va);
                if(item){
                    return {
                        value:item.value,
                        label:item.label
                    };
                }
                return null
            }))
        }
    }, [value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#000',
            background: state.isSelected ? '#0364ff' : '#fff',
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: 'gray'
        })
    }), [])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectSubEstadoInstCancelada.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectSubEstadoInstCancelada;